import { useColorModeValue } from '@ecoinvent/ui';
import { Handle, Position } from '@xyflow/react';
import type { NodeProps } from '@xyflow/react';

import FlowGraphCard from './FlowGraphCard';

export type DatasetNodeData = {
  name: string;
  inputCount: number;
  outputCount: number;
  geography?: string;
  timePeriod?: string;
  unit?: string;
  activityType?: string;
  onViewDataset?: () => void;
};

const DatasetNode = ({ data }: NodeProps) => {
  const { name, inputCount, outputCount, geography, timePeriod, unit, activityType, onViewDataset } = data as DatasetNodeData;

  const handleBg = '#D4D4D4';
  const handleBorderColor = useColorModeValue('#FFFFFF', '#575454');

  const baseHandle: React.CSSProperties = {
    background: handleBg,
    border: `2px solid ${handleBorderColor}`,
    width: 8,
    height: 8,
    borderRadius: '50%',
    top: '50%',
    boxShadow: '0 1px 2px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.10)',
  };

  const leftHandle: React.CSSProperties = {
    ...baseHandle,
    transform: 'translate(calc(-50% - 9px), -50%)',
  };
  const rightHandle: React.CSSProperties = {
    ...baseHandle,
    transform: 'translate(calc(50% + 9px), -50%)',
  };

  return (
    <div className="nopan nodrag" style={{ cursor: 'default' }}>
      <Handle id="target-center" type="target" position={Position.Left} style={leftHandle} />

      <FlowGraphCard
        variant="dataset"
        name={name}
        inputCount={inputCount}
        outputCount={outputCount}
        geography={geography}
        timePeriod={timePeriod}
        unit={unit}
        activityType={activityType}
        onViewDataset={onViewDataset}
      />

      <Handle id="source-center" type="source" position={Position.Right} style={rightHandle} />
    </div>
  );
};

export default DatasetNode;
